/* Fereastra „Adăugat în coș”: confirmare + stadiul transportului gratuit + recomandări din alte categorii.
   Se declanșează din cart-drawer.js (renderContents) prin evenimentul `xplode:added-to-cart`. */
(function () {
  if (window.xplodeAddedToCart) return;
  window.xplodeAddedToCart = true;

  var root = document.documentElement;
  var MIN_ITEMS = parseInt(root.getAttribute('data-free-shipping-items') || '0', 10);
  var MIN_SPEND = parseInt(root.getAttribute('data-free-shipping-spend') || '0', 10);
  var cache = {};
  var overlay, popup, body, lastFocus;

  function getJSON(url) {
    if (!cache[url]) {
      cache[url] = fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : {}; })
        .catch(function () { return {}; });
    }
    return cache[url];
  }

  function money(c) {
    if (typeof window.formatMoney === 'function') {
      try { return window.formatMoney(c); } catch (e) { /* fallback */ }
    }
    return (c / 100).toFixed(2).replace('.', ',') + ' lei';
  }

  function cents(v) { return typeof v === 'string' ? Math.round(parseFloat(v) * 100) : (v || 0); }

  function img(src, width) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function build() {
    overlay = el('div', 'atc-overlay');
    popup = el('div', 'atc-popup');
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-label', 'Produs adăugat în coș');
    popup.tabIndex = -1;
    body = el('div', 'atc-popup__body');
    popup.appendChild(body);
    document.body.appendChild(overlay);
    document.body.appendChild(popup);
    overlay.addEventListener('click', hide);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) hide();
    });
  }

  function hide() {
    if (!popup) return;
    popup.classList.remove('is-open');
    overlay.classList.remove('is-open');
    root.classList.remove('atc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function shippingBox(cart) {
    if (!MIN_ITEMS && !MIN_SPEND) return null;
    var box = el('div', 'atc-ship');
    var reached = (MIN_ITEMS && cart.item_count >= MIN_ITEMS) || (MIN_SPEND && cart.total_price >= MIN_SPEND);
    var progress = 0;
    if (MIN_ITEMS) progress = Math.max(progress, cart.item_count / MIN_ITEMS);
    if (MIN_SPEND) progress = Math.max(progress, cart.total_price / MIN_SPEND);
    var text = el('div');
    if (reached) {
      box.classList.add('atc-ship--done');
      text.innerHTML = '<strong>Ai transport gratuit!</strong> 🎉';
    } else if (MIN_ITEMS) {
      var left = MIN_ITEMS - cart.item_count;
      text.innerHTML = 'Mai adaugă <strong>' + (left === 1 ? 'un produs' : left + ' produse') + '</strong> și ai <strong>transport gratuit</strong>.';
    } else {
      text.innerHTML = 'Mai adaugă <strong>' + money(MIN_SPEND - cart.total_price) + '</strong> și ai <strong>transport gratuit</strong>.';
    }
    box.appendChild(text);
    var bar = el('div', 'atc-ship__bar');
    var fill = el('span');
    fill.style.width = Math.min(100, Math.round(progress * 100)) + '%';
    bar.appendChild(fill);
    box.appendChild(bar);
    return box;
  }

  // Categoriile magazinului (colecții „produs-*”). Arătăm câte un produs din fiecare categorie diferită de cea adăugată.
  var CATEGORIES = [
    { handle: 'produs-tricou', label: 'Tricouri', match: /tricou/i },
    { handle: 'produs-hanorac', label: 'Hanorace', match: /hanorac/i },
    { handle: 'produs-body', label: 'Body bebeluși', match: /body/i },
    { handle: 'produs-sacosa', label: 'Sacoșe', match: /saco/i },
    { handle: 'produs-set', label: 'Seturi', match: /^set/i }
  ];

  function loadRecs(item, inCartIds, list, section) {
    var addedType = item.product_type || '';
    var others = CATEGORIES.filter(function (c) { return !c.match.test(addedType); }).slice(0, 4);
    Promise.all(others.map(function (c) {
      return getJSON('/collections/' + c.handle + '/products.json?limit=24').then(function (d) {
        var pool = (d.products || []).filter(function (p) {
          return inCartIds.indexOf(p.id) === -1 && (p.variants || []).some(function (v) { return v.available !== false; });
        });
        return pool.length ? { cat: c, product: pool[Math.floor(Math.random() * pool.length)] } : null;
      });
    })).then(function (picks) {
      picks = picks.filter(Boolean);
      if (!picks.length) { section.hidden = true; return; }
      list.innerHTML = '';
      picks.forEach(function (pick) {
        var p = pick.product;
        var v = (p.variants || []).filter(function (x) { return x.available !== false; })[0] || p.variants[0];
        var a = el('a', 'atc-rec');
        a.href = '/products/' + p.handle;
        var image = p.images && p.images[0];
        if (image) {
          var im = el('img');
          im.src = img(image, 300);
          im.alt = '';
          im.loading = 'lazy';
          a.appendChild(im);
        }
        a.appendChild(el('span', 'atc-rec__type', pick.cat.label));
        a.appendChild(el('span', 'atc-rec__name', p.title));
        var price = el('span', 'atc-rec__price');
        var cp = cents(v.price);
        var cc = cents(v.compare_at_price);
        price.innerHTML = money(cp) + (cc > cp ? '<s>' + money(cc) + '</s>' : '');
        a.appendChild(price);
        list.appendChild(a);
      });
    });
  }

  function show(item) {
    if (!item || !item.product_id) return;
    if (!popup) build();
    lastFocus = document.activeElement;
    body.innerHTML = '';

    var head = el('div', 'atc-popup__head');
    var title = el('p', 'atc-popup__title');
    title.innerHTML = '<span class="atc-popup__check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>Adăugat în coș';
    head.appendChild(title);
    var close = el('button', 'atc-popup__close');
    close.type = 'button';
    close.setAttribute('aria-label', 'Închide');
    close.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    close.addEventListener('click', hide);
    head.appendChild(close);
    body.appendChild(head);

    var row = el('div', 'atc-item');
    if (item.image) {
      var im = el('img');
      im.src = img(item.image, 200);
      im.alt = '';
      row.appendChild(im);
    }
    var info = el('div');
    info.appendChild(el('p', 'atc-item__name', item.product_title || item.title));
    if (item.variant_title) info.appendChild(el('p', 'atc-item__variant', item.variant_title.replace(/ \/ /g, ' · ') + (item.quantity > 1 ? ' · ' + item.quantity + ' buc.' : '')));
    var price = el('div', 'atc-item__price');
    var unit = item.final_price != null ? item.final_price : item.price;
    price.innerHTML = money(unit) + (item.original_price > unit ? ' <s style="color:#888;font-weight:500;font-size:1.25rem">' + money(item.original_price) + '</s>' : '');
    info.appendChild(price);
    row.appendChild(info);
    body.appendChild(row);

    var shipHolder = el('div');
    body.appendChild(shipHolder);

    var actions = el('div', 'atc-actions');
    var viewCart = el('a', 'atc-btn atc-btn--ghost', 'Vezi coșul');
    viewCart.href = (window.routes && window.routes.cart_url) || '/cart';
    var checkout = el('a', 'atc-btn atc-btn--primary', 'Finalizează comanda');
    checkout.href = '/checkout';
    actions.appendChild(viewCart);
    actions.appendChild(checkout);
    body.appendChild(actions);
    var cont = el('button', 'atc-continue', 'Continuă cumpărăturile');
    cont.type = 'button';
    cont.addEventListener('click', hide);
    body.appendChild(cont);

    var recs = el('div', 'atc-recs');
    recs.appendChild(el('p', 'atc-recs__title', 'Descoperă și alte categorii'));
    recs.appendChild(el('p', 'atc-recs__sub', 'Tricouri, hanorace, body-uri, sacoșe și seturi XPLODE'));
    var list = el('div', 'atc-recs__list');
    recs.appendChild(list);
    body.appendChild(recs);

    root.classList.add('atc-lock');
    overlay.classList.add('is-open');
    popup.classList.add('is-open');
    popup.scrollTop = 0;
    popup.focus({ preventScroll: true });

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var box = shippingBox(cart);
        if (box) shipHolder.appendChild(box);
        loadRecs(item, cart.items.map(function (i) { return i.product_id; }), list, recs);
      })
      .catch(function () { loadRecs(item, [item.product_id], list, recs); });
  }

  document.addEventListener('xplode:added-to-cart', function (e) {
    var state = e.detail || {};
    // /cart/add întoarce linia adăugată; la adăugări multiple, un obiect cu `items`
    var item = state.items && state.items.length ? state.items[0] : state;
    show(item);
  });
})();
